<template>
  <div>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewItem"
          >mdi-eye</v-icon
        >
      </template>
      <span>View</span>
    </v-tooltip>
    <v-tooltip bottom>
      <template #activator="{ on, attrs }">
        <v-icon
          class="ml-2 mr-1"
          color="primary"
          v-on="on"
          v-bind="attrs"
          @click="viewDaDocument"
          >mdi-file-document-multiple-outline</v-icon
        >
      </template>
      <span>POD View</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  methods: {
    viewItem() {
      this.params.context.parentComponent.viewDeliveryAdviceDetails(
        this.params.data.id
      );
    },
    viewDaDocument(){
      this.params.context.parentComponent.viewDADocuments(
        this.params.data.id
      );
    }
  },
};
</script>

<style>
</style>